<template>
    <div>
      <form>

        <input tyle="text" v-model="email" class="mb-3 form-control" @keydown.enter.prevent="subscribe" autocomplete="email" placeholder="crystalchild@gmail.com">
        <div class="btn btn-outline-secondary" v-on:click="subscribe">Subscribe</div>
        <div class="d-block"><div v-show="loading" class="text-right"><i class="fas fa-spinner fa-spin mr-1"></i>Loading</div></div>
        
      </form>
    </div>
</template>

<script>
    export default {
        data() {
            return  {
                email:null,
                loading: false
            }       
        },
        http: {
            root: '/root',
            headers: {
                'X-CSRF-Token': Laravel.csrfToken
            }
        },
        methods: {
            subscribe()
            {
                this.loading = true;

                var $data = {
                    'email' :      this.email,
                }
                this.$http.post(
                    '/ajax/newsletter/subscribe', 
                    $data
                ).then(function(success) {
                    $("body").overhang({
                        type: "success",
                        closeConfirm: true,
                        html: true,
                        message: "<i class='fas fa-check-circle'></i> Successfully subscribed! Check your email for further instructions."
                    });
                     this.loading = false;
                }, function(error) {
                    $("body").overhang({
                        type: "error",
                        duration: 3,
                        html: true,
                        message: error.body.message
                    });
                     this.loading = false;
                });
            }
        }
    };
</script>
